"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchJSON = fetchJSON;
async function fetchJSON(url) {
    const result = await fetch(url);
    return result.json();
}
//# sourceMappingURL=fetchJSON.js.map